import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { webSubscriptionsModule } from '@/modules/subscriptions';
import { webCampaign } from '@/modules/webCampaign';
import { StripeV2SubscriptionPrice } from '@/services/stripe/dto';

import {
  PaymentDescriptionRowStyles,
  PaymentDescriptionStyles,
} from './PaymentDescription.styles';

export const PaymentDescription: React.FC<{
  selectedPlan: StripeV2SubscriptionPrice;
}> = ({ selectedPlan }) => {
  const isSimpleSelectPlan =
    webCampaign.setup.paywallNotes.includes('simple-select-plan');
  const subscriptionData = webSubscriptionsModule.getPlanConfig(selectedPlan);

  const sale = (
    subscriptionData.basePriceWithoutSale - subscriptionData.basePrice
  ).toFixed(2);

  if (isSimpleSelectPlan) {
    return (
      <PaymentDescriptionStyles>
        <PaymentDescriptionRowStyles>
          <UiTypography variant="title-large">Total</UiTypography>
          <UiTypography variant="title-large">
            ${subscriptionData.basePrice}
          </UiTypography>
        </PaymentDescriptionRowStyles>
      </PaymentDescriptionStyles>
    );
  }

  return (
    <PaymentDescriptionStyles>
      <PaymentDescriptionRowStyles>
        <UiTypography variant="body-medium">
          {selectedPlan.label} Plan
        </UiTypography>
        <UiTypography variant="body-medium">
          ${subscriptionData.basePriceWithoutSale}
        </UiTypography>
      </PaymentDescriptionRowStyles>

      <PaymentDescriptionRowStyles>
        <UiTypography variant="body-medium">Discount</UiTypography>
        <UiTypography variant="body-medium" color="danger">
          -${sale}
        </UiTypography>
      </PaymentDescriptionRowStyles>

      <PaymentDescriptionRowStyles>
        <UiTypography variant="title-large">Total</UiTypography>
        <UiTypography variant="title-large">
          ${subscriptionData.basePrice}
        </UiTypography>
      </PaymentDescriptionRowStyles>
    </PaymentDescriptionStyles>
  );
};
